'use strict';

var _ = require('lodash');
var AdvancedHepGridDuplicateRowButtonController = function AdvancedHepGridDuplicateRowButtonController($scope, advancedHepSystemConfigButtonsUtilsService, systemConfigButtonsUtilsService) {
  var gridPanel = $scope.gridPanelScope;
  $scope.isGridEditable = gridPanel.jqxGridSettings.editable;
  $scope.isDuplicateButtonShown = false;
  $scope.onRowSelection = function (selectedRows) {
    $scope.isDuplicateButtonShown = !$scope.isDefaultLevel && $scope.isGridEditable && selectedRows.length > 0;
    $scope.selectedRows = selectedRows;
  };
  function cloneNewRow(oldRow) {
    var newRow = _.cloneDeep(oldRow);
    newRow.isRowEditable = true;
    newRow.isNewlyAdded = true;
    newRow.hepType = $scope.selected.type;
    return newRow;
  }
  $scope.duplicateRows = function () {
    _.chain($scope.selectedRows).reverse().forEach(function (selectedRow) {
      systemConfigButtonsUtilsService.addRowToGrid(cloneNewRow(selectedRow), gridPanel);
    }).value();
    advancedHepSystemConfigButtonsUtilsService.refreshGrid(gridPanel);
  };
};
AdvancedHepGridDuplicateRowButtonController.$inject = ['$scope', 'AdvancedHepSystemConfigButtonsUtilsService', 'SystemConfigButtonsUtilsService'];
module.exports = AdvancedHepGridDuplicateRowButtonController;